/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';

import { IUiPermissionApiItem, IUserPermission } from '@core/models';
import { MongoUser } from '@core/models/mongo';
import { Client, IUserPermissionType } from '@truckstop-tms/zuum-lib';

export const load = createAction('[ClientDetails:Users] Load', props<{ companyId: string }>());
export const loadSuccess = createAction('[ClientDetails:Users] Load Success', props<{ users: MongoUser[] }>());
export const loadFailure = createAction('[ClientDetails:Users] Load Failure', props<{ errorMessage: string }>());

export const loadUserPermissions = createAction('[Settings:User] Load user permissions', props<{ userId: string }>());
export const loadUserPermissionsSuccess = createAction(
  '[Settings:User] Load user permissions Success',
  props<{ permissions: IUserPermission }>()
);
export const loadUserPermissionsFailure = createAction(
  '[Settings:User] Load user permissions Failure',
  props<{ errorMessage: string }>()
);

export const openModalDialog = createAction(
  '[ClientDetails:Users] Open Modal Dialog',
  props<{
    client: Client;
    users: MongoUser[];
    permissions: IUiPermissionApiItem[] | null;
    perSeatPrice?: number;
    user?: MongoUser;
  }>()
);

export const createUser = createAction(
  '[ClientDetails:Users] Create User',
  props<{ clientId: number; user: MongoUser; permissions?: IUserPermissionType[]; additionals?: string[] }>()
);
export const createUserSuccess = createAction(
  '[ClientDetails:Users] Create User Success',
  props<{ clientId: number; user: MongoUser; permissions?: IUserPermissionType[], additionals?: string[] }>()
);
export const createUserFailure = createAction(
  '[ClientDetails:Users] Create User Failure',
  props<{ errorMessage: string }>()
);

export const updateUser = createAction(
  '[ClientDetails:Users] Update User',
  props<{
    clientId: number;
    user: Partial<MongoUser>;
    oldUser?: MongoUser;
    permissions?: IUserPermissionType[];
    oldPermissions?: IUserPermission;
    additionals?: string[];
  }>()
);
export const updateUserSuccess = createAction(
  '[ClientDetails:Users] Update User Success',
  props<{
    clientId: number;
    user: Partial<MongoUser>;
    oldUser?: MongoUser;
    permissions?: IUserPermissionType[];
    oldPermissions?: IUserPermission;
    additionals?: string[];
  }>()
);
export const updateUserFailure = createAction(
  '[ClientDetails:Users] Update User Failure',
  props<{ errorMessage: string }>()
);

export const remove = createAction('[ClientDetails:Users] Remove', props<{ user: MongoUser; clientId: number }>());
export const removeSuccess = createAction('[ClientDetails:Users] Remove Success', props<{ user: MongoUser }>());
export const removeFailure = createAction('[ClientDetails:Users] Remove Failure', props<{ errorMessage: string }>());

export const resendInviteBroker = createAction(
  '[ClientDetails:Users] Resend Invite Broker',
  props<{ user: MongoUser; client: Client }>()
);
export const resendInviteShipper = createAction(
  '[ClientDetails:Users] Resend Invite Shipper',
  props<{ user: MongoUser; client: Client }>()
);
export const resendInviteCarrier = createAction(
  '[ClientDetails:Users] Resend Invite Carrier',
  props<{ user: MongoUser; client: Client }>()
);
export const resendInviteSuccess = createAction(
  '[ClientDetails:Users] Resend Invite Success',
  props<{ user: MongoUser; client: Client }>()
);
export const resendInviteFailure = createAction(
  '[ClientDetails:Users] Resend Invite Failure',
  props<{ errorMessage: string }>()
);
